/**
 * Shared class string for icon-only trigger buttons in the nav utility bar
 * (UserMenu, LocalizationNavbarMenu).
 */
export const navIconButtonClass =
  'group flex size-[36px] shrink-0 cursor-pointer items-center justify-center rounded-md border-none bg-transparent text-gray-400 hover:text-white appearance-none';
